import React from 'react';
import { getIn } from 'formik';
import { MentionsInput, Mention } from 'react-mentions';
import classNames from 'classnames/bind';

import styles from '../fieldStyles';

const cx = classNames.bind(styles);

const CommentField = ({
  field,
  form: { touched, errors, setFieldValue },
  analyticsTag,
  ...props
}) => {
  const { note, mentionables, id } = props;
  const value = field.value || field.value === 0 ? field.value : '';
  const isTouched = getIn(touched, field.name);
  const error = getIn(errors, field.name);

  const boxWrapStyle = cx({
    boxWrap: true,
    hasUserContent: Boolean(value)
  });

  return (
    <div className={styles.fieldContainer}>
      <div className={boxWrapStyle} id={id} data-heap={analyticsTag}>
        <MentionsInput
          value={value}
          onChange={e => setFieldValue(field.name, e.target.value)}
          className="mentionsInput"
          allowspaceinquery="true"
        >
          <Mention trigger="@" data={mentionables} appendSpaceOnAdd />
        </MentionsInput>
      </div>
      {isTouched && error && <div className={styles.fieldError}>{error}</div>}
      {note && <div className={styles.fieldNote}>{note}</div>}
    </div>
  );
};

export default CommentField;
